import {
    CREATE_ACCOUNT_MODAL_STATE_CHANGED,
    ADD_ADDRESS_MODAL_STATE_CHANGED,
    ADDRESS_MODAL_DATA_SET,
    ELIGIBILITY_MODAL_INITIALIZED,
    ELIGIBILITY_MODAL_STATE_CHANGED,
    ALERT_MODAL_STATE_CHANGED,
    ALERT_MODAL_DATA_SET,
    WIZARD_IN_PROGRESS_MODAL_STATE_CHANGED,
    WIZARD_IN_PROGRESS_MODAL_DATA_SET,
    LEASE_MODAL_STATE_CHANGED,
    PROCESS_LEASE_MODAL_STATE_CHANGED,
    PROCESS_LEASE_MODAL_DATA_SET,
    ALREADY_APPROVED_MODAL_STATE_CHANGED
} from "../Constants";

export function updateCreateAccountModalState(show) {
    return {
        type: CREATE_ACCOUNT_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function updateAddAddressModalState(show) {
    return {
        type: ADD_ADDRESS_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function setAddAddressModalData(data) {
    return {
        type: ADDRESS_MODAL_DATA_SET,
        payload: data
    };
}

export function updateAlertModalState(show) {
    return {
        type: ALERT_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function setAlertData(data) {
    return {
        type: ALERT_MODAL_DATA_SET,
        payload: data
    };
}

export function updateWizardInProgressModalState(show) {
    return {
        type: WIZARD_IN_PROGRESS_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function setWizardInProgressData(data) {
    return {
        type: WIZARD_IN_PROGRESS_MODAL_DATA_SET,
        payload: data
    };
}

export function initializeEligibilityModal(val) {
    return {
        type: ELIGIBILITY_MODAL_INITIALIZED,
        payload: val
    };
}

export function updateEligibilityModalState(show) {
    return {
        type: ELIGIBILITY_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function updateLeaseModalState(show) {
    return {
        type: LEASE_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function updateProcessLeaseModalState(show) {
    return {
        type: PROCESS_LEASE_MODAL_STATE_CHANGED,
        payload: show
    };
}

export function setProcessLeaseData(data) {
    return {
        type: PROCESS_LEASE_MODAL_DATA_SET,
        payload: data
    };
}

export function updateAlreadyApprovedModalState(show) {
    return {
        type: ALREADY_APPROVED_MODAL_STATE_CHANGED,
        payload: show
    };
}